var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyPhnHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 81,
    viewBox: "0 0 62 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 1V63H1V1H37Z",
    fill: "#FDE8F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 10.1176V1H1V63H19",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16H62V81H24V16Z",
    fill: "#EC187B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 68.5,
    r: 3,
    fill: "#FDE8F2",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyPhnHover);
export default __webpack_public_path__ + "static/media/verifyPhnHover.38d74f65a4794267d0a912ade16433ca.svg";
export { ForwardRef as ReactComponent };